import { GridSortModel } from "@mui/x-data-grid-pro";
import { D2DOrdersFilters } from "../types";
import { GroupedD2DOrder } from "../utils/orderGrouping";

export enum D2DOrdersActionsType {
  SET_D2D_ORDERS = "SET_D2D_ORDERS",
  SET_IS_LOADING = "SET_IS_LOADING",
  SET_IS_TECHNICAL_ERROR = "SET_IS_TECHNICAL_ERROR",
  SET_IS_DOWNLOADING = "SET_IS_DOWNLOADING",
  SET_CURRENT_PAGE = "SET_CURRENT_PAGE",
  SET_PAGE_ROW_SIZE = "SET_PAGE_ROW_SIZE",
  SET_SORT_MODEL = "SET_SORT_MODEL",
  SET_FILTER = "SET_FILTER",
}

type SetD2DOrdersAction = {
  type: D2DOrdersActionsType.SET_D2D_ORDERS;
  payload: {
    d2dOrders: GroupedD2DOrder[];
    totalOrders: number;
  };
};

type SetIsLoadingAction = {
  type: D2DOrdersActionsType.SET_IS_LOADING;
  payload: boolean;
};

type SetIsTechnicalErrorAction = {
  type: D2DOrdersActionsType.SET_IS_TECHNICAL_ERROR;
  payload: boolean;
};

type SetIsDownloadingAction = {
  type: D2DOrdersActionsType.SET_IS_DOWNLOADING;
  payload: boolean;
};

type SetCurrentPageAction = {
  type: D2DOrdersActionsType.SET_CURRENT_PAGE;
  payload: number;
};

type SetPageRowSizeAction = {
  type: D2DOrdersActionsType.SET_PAGE_ROW_SIZE;
  payload: number;
};

type SetSortModelAction = {
  type: D2DOrdersActionsType.SET_SORT_MODEL;
  payload: GridSortModel;
};

type SetFilterAction = {
  type: D2DOrdersActionsType.SET_FILTER;
  payload: D2DOrdersFilters;
};

export type D2DOrdersActions =
  | SetD2DOrdersAction
  | SetIsLoadingAction
  | SetIsTechnicalErrorAction
  | SetIsDownloadingAction
  | SetCurrentPageAction
  | SetPageRowSizeAction
  | SetSortModelAction
  | SetFilterAction;

export function setD2DOrdersAction(payload: {
  d2dOrders: GroupedD2DOrder[];
  totalOrders: number;
}): SetD2DOrdersAction {
  return {
    type: D2DOrdersActionsType.SET_D2D_ORDERS,
    payload,
  };
}

export function setIsLoadingAction(isLoading: boolean): SetIsLoadingAction {
  return {
    type: D2DOrdersActionsType.SET_IS_LOADING,
    payload: isLoading,
  };
}

export function setIsTechnicalErrorAction(
  isTechnicalError: boolean
): SetIsTechnicalErrorAction {
  return {
    type: D2DOrdersActionsType.SET_IS_TECHNICAL_ERROR,
    payload: isTechnicalError,
  };
}

export function setIsDownloadingAction(
  isDownloading: boolean
): SetIsDownloadingAction {
  return {
    type: D2DOrdersActionsType.SET_IS_DOWNLOADING,
    payload: isDownloading,
  };
}

export function setCurrentPageAction(
  currentPage: number
): SetCurrentPageAction {
  return {
    type: D2DOrdersActionsType.SET_CURRENT_PAGE,
    payload: currentPage,
  };
}

export function setPageRowSizeAction(
  pageRowSize: number
): SetPageRowSizeAction {
  return {
    type: D2DOrdersActionsType.SET_PAGE_ROW_SIZE,
    payload: pageRowSize,
  };
}

export function setFilterAction(filters: D2DOrdersFilters): SetFilterAction {
  return {
    type: D2DOrdersActionsType.SET_FILTER,
    payload: filters,
  };
}
export function setSortModelAction(
  sortModel: GridSortModel
): SetSortModelAction {
  return {
    type: D2DOrdersActionsType.SET_SORT_MODEL,
    payload: sortModel,
  };
}
